import { AxiosInstance } from 'axios'
import Rollbar from 'rollbar'

export type DownloadParams = {
  crunchUUID: string
  bodyData: BodyDataDownload
}

export type BodyDataDownload = {
  document: DocumentDataDownload
  checklists: ChecklistDataDownload[]
  playbooks: PlaybookDataDownload[]
}

export type DownloadPdfData = {
  offsets: Record<string, { first: number; last: number }>
  pdf: Blob
}

export type DownloadPdfResponse = {
  data: DownloadPdfData
  error?: unknown
}

type DocumentDataDownload = {
  include_document: boolean
  include_notes_markups: boolean
  include_project_details: boolean
  include_provision_highlights: boolean
  include_key_provision_matches: boolean
  use_original_document: boolean
  compress_text: boolean
  landscape: boolean
  timezone: string
}

export type ChecklistDataDownload = {
  uuid: string
  template_uuid?: string
  include: boolean
  include_option1: boolean
  include_option2: boolean
  include_option3: boolean
  include_gen_ai_summary: boolean
  include_notes: boolean
  include_subquestions: boolean
  include_descriptions: boolean
  include_no_answer: boolean
}

type PlaybookDataDownload = {
  uuid: string
  include: boolean
}
export const postDownloadPdf = async (
  svcCrunchApiClient: AxiosInstance,
  { crunchUUID, bodyData }: DownloadParams,
  rollbar: Rollbar
): Promise<DownloadPdfResponse> => {
  const { data: responseData, headers } =
    await svcCrunchApiClient.post<ArrayBuffer>(
      `/api/documents/${crunchUUID}/download`,
      bodyData,
      {
        responseType: 'arraybuffer',
      }
    )

  if (!headers['x-dc-download-offsets']) {
    rollbar.error('Missing x-dc-download-offsets header in download response')
    return {
      data: {
        offsets: {},
        pdf: new Blob([]),
      },
      error: new Error('Missing x-dc-download-offsets header'),
    }
  }

  try {
    return {
      data: {
        offsets: JSON.parse(headers['x-dc-download-offsets']),
        pdf: new Blob([responseData], {
          type: 'application/pdf',
        }),
      },
    }
  } catch (error) {
    rollbar.error(
      'Failed to parse x-dc-download-offsets header',
      error instanceof Error ? error : new Error('An unexpected error occurred')
    )
    return {
      data: {
        offsets: {},
        pdf: new Blob([responseData], { type: 'application/pdf' }),
      },
      error: new Error('Invalid x-dc-download-offsets header format'),
    }
  }
}
